export default __webpack_public_path__ + "static/media/dropdown-arrow-up.4893c143.svg";